import { apiJson } from "../utils/api.js";
import { handleApiError } from "../utils/errorHandler.js";

const BASE_URL = "/kms/chef-bot";

/**
 * Chat related service functions
 */
const chatService = {
    /**
     * Get list of all customer chats
     */
    getChats: async () => {
        try {
            const response = await apiJson.get(`${BASE_URL}/chats`);
            return response.data;
        } catch (error) {
            handleApiError(error);
            throw error;
        }
    },

    /**
     * Get message history with a specific customer
     */
    getMessages: async (customerId) => {
        try {
            const response = await apiJson.get(`${BASE_URL}/messages/${customerId}`);
            return response.data;
        } catch (error) {
            handleApiError(error);
            throw error;
        }
    },

    /**
     * Send a text message to a customer
     */
    sendMessage: async (customerId, text) => {
        try {
            const response = await apiJson.post(`${BASE_URL}/chats/${customerId}/send`, { text });
            return response.data;
        } catch (error) {
            handleApiError(error);
            throw error;
        }
    },

    /**
     * Broadcast the current menu to all customers
     */
    broadcastMenu: async () => {
        try {
            const response = await apiJson.post(`${BASE_URL}/broadcast-menu`);
            return response.data;
        } catch (error) {
            handleApiError(error);
            throw error;
        }
    },

    /**
     * Mark all messages in a chat as read
     */
    markAsRead: async (customerId) => {
        try {
            const response = await apiJson.post(`${BASE_URL}/chats/${customerId}/read`);
            return response.data;
        } catch (error) {
            // Silently handle read errors as it's a background action
            console.error('Failed to mark as read:', error);
            return null;
        }
    },

    /**
     * Get telegram customer details by user ID
     */
    getCustomerByUserId: async (userId) => {
        try {
            const response = await apiJson.get(`${BASE_URL}/customers/by-user/${userId}`);
            return response.data;
        } catch (error) {
            handleApiError(error);
            throw error;
        }
    }
};

export default chatService;
